import { useState } from "react";
import _ from "lodash";

import HexCard from "../../../../components/HexCard";
import { showErrorNotification } from "../../../../utils/common-utils";

import OrderModal from "./OrderModal";
import PaymentProcessor from "../../../../components/PaymentProcessor";
import { getPaymentInfo } from "./payment-utils";

const PaymentMethodsCard = ({ updateTimer }) => {
  const [transactionDetails, setTransactionDetails] = useState({});

  const onClose = () => {
    setTransactionDetails({});
  };

  const onSuccess = (transactionIds) => {
    updateTimer();
    setTransactionDetails({ transactionIds });
  };

  const onFailure = (error) => {
    showErrorNotification({ body: error });
  };

  const info = getPaymentInfo();

  return (
    <HexCard className={"content-card"}>
      {!_.isEmpty(transactionDetails) && (
        <OrderModal
          onClose={onClose}
          {...transactionDetails}
          showTimer={() => updateTimer()}
        />
      )}

      <PaymentProcessor onSuccess={onSuccess} onFailure={onFailure} {...info} />
    </HexCard>
  );
};

export default PaymentMethodsCard;
